import {
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
} from "@mui/material";
import theme from "../../../theme";
import { OpenFormButton } from "../../ReusableComponents/OpenFormButton";
import { UserHistoryPanel } from "../../UserHistory/UserHistoryPanel";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";

// Sorting the history by date
const sortByMostRecent = (history) => {
  return [...history].sort((a, b) => {
    const timeA = new Date(a.time).getTime();
    const timeB = new Date(b.time).getTime();
    if (!timeA && timeB) return 1;
    if (!timeB && timeA) return -1;
    return timeB - timeA;
  });
};

export const GenerateInsightsFloatingButtons = ({
  isFormOpen,
  history,
  exporting,
  exportSuccess,
  exportError,
  openForm,
  onExport,
  setExportError,
  setExportSuccess,
  showHistoryPanelFloatingButton,
  rerunFromHistory,
  onDeleteHistoryItem,
  currentlyGenerating,
  currentHistoryId,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        height: "80%",
        gridTemplateRows: "max-content max-content 1fr max-content",
        gap: "16px",
        position: "fixed",
        right: 32,
        bottom: 32,
        zIndex: theme.zIndex.drawer,
        top: "60px",
        mt: "20px",
      }}
    >
      {!isFormOpen && !exporting && (
        <div>
          <OpenFormButton
            onClick={openForm}
            tooltip="Open Form"
            icon={DescriptionIcon}
            variant="outlined"
          />
        </div>
      )}
      {showHistoryPanelFloatingButton && (
        <div>
          <UserHistoryPanel
            history={sortByMostRecent(history)}
            rerunFromHistory={rerunFromHistory}
            onDeleteHistoryItem={onDeleteHistoryItem}
            currentlyGenerating={currentlyGenerating}
            currentHistoryId={currentHistoryId}
          />
        </div>
      )}

      <SpeedDial
        ariaLabel="Actions"
        icon={<SpeedDialIcon />}
        FabProps={{
          size: "medium",
          disabled: exporting,
          sx: {
            color: "primary.main",
            backgroundColor: "primary.brandMain",
            "&:hover": {
              color: "primary.brandMain",
              backgroundColor: "primary.main",
            },
          },
        }}
      >
        <SpeedDialAction
          key="Export to PowerPoint"
          icon={<DownloadIcon />}
          slotProps={{
            tooltip: {
              title: "Export to PowerPoint",
            },
            fab: {
              sx: {
                color: "primary.main",
                backgroundColor: "primary.white",
                "&:hover": {
                  color: "primary.main",
                  backgroundColor: "primary.white",
                },
              },
            },
          }}
          onClick={onExport}
        />
      </SpeedDial>
      <Backdrop open={exporting} sx={{ color: "primary.white", zIndex: 1300 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={!!exportError}
        autoHideDuration={6000}
        onClose={() => setExportError(null)}
      >
        <Alert severity="error" onClose={() => setExportError(null)}>
          {exportError}
        </Alert>
      </Snackbar>
      <Snackbar
        open={exportSuccess}
        autoHideDuration={3000}
        onClose={() => setExportSuccess(false)}
      >
        <Alert severity="success" onClose={() => setExportSuccess(false)}>
          PowerPoint exported successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};
